var tjx = {
    actionButton: null,
    certificateBalance: true,
    certificateExpirationDays: 90,
    certificateValue: 10,
    disclaimerTranslationKey: 'tjxDisclaimer',
    howToEarnPointsHeader: 'fullDetailsPage.howToEarnPointsHeader',
    faqs: 'https://promotions.tjxrewards.com/promotion-faq.html',
    faqsSnapshot: true,
    isRewardTiers: false,
    isValuePropBanner: true,
    links: [
        {
            href: 'https://tjmaxx.tjx.com/store/index.jsp',
            text: 'tjmaxx.com'
        },
        {
            href: 'https://www.marshalls.com/us/store/index.jsp',
            text: 'marshalls.com'
        },
        {
            href: 'https://www.sierra.com/',
            text: 'sierra.com'
        }
    ],
    es: {
        termsAndConditionsLink: 'https://tjx.syf.com/essimages/cs/groups/ess_webasset/plcc/@tjx/en/html/ess052020.html'
    },
    en: {
        termsAndConditionsLink: 'https://tjx.syf.com/essimages/cs/groups/ess_webasset/plcc/@tjx/en/html/ess052020.html'
    },
    translationKey: 'faqs.description',
    snapshotTranslationKey: 'faqs.description',
    translationViewPrintKey: 'tjxViewPrint',
    DUAL_CARD: {
        banner: 'tjx-banner-md.png',
        certificateHistoryImg: 'tjx-certHistory-md.png',
        certificateHistory: true,
        rewardsBalance: true,
        valuePropImg: 'tjx-valueProp-dc.png',
        en: {
            disclaimer: 'If current points equal or exceed 1,000, a Rewards Certificate will be issued digitally within 24-48 hours. It will also be sent with your next statement.',
            propositions: [
                {
                    description: "Earn 5% back in Rewards points every time you shop our family of stores. That's 5 points for every $1 spent.*",
                    heading: 'earn',
                    points: '5% back'
                },
                {
                    description: "Earn 1% back in Rewards points when you shop anywhere else Mastercard is accepted. That's 1 point for every $1 spent.*",
                    heading: 'earn',
                    points: '1% back'
                }
            ]
        },
        es: {
            disclaimer: 'Si los puntos actuales igualan o superan los 1000, se emitirá digitalmente un Certificado de Recompensa dentro de 24 a 48 horas. También se enviará con su próximo estado de cuenta.',
            propositions: [
                {
                    description: 'Obtenga 5% de reembolso en puntos de Recompensas cada vez que compra en nuestra familia de tiendas. Equivale a 5 puntos por cada $1 gastado.*',
                    heading: 'obtenga',
                    points: '5% de reembolso'
                },
                {
                    description: 'Obtenga 1% de reembolso en puntos de Recompensas cuando compra en cualquier otro lugar donde se acepte Mastercard. Equivale a 1 punto por cada $1 gastado.*',
                    heading: 'obtenga',
                    points: '1% de reembolso'
                }
            ]
        }
    },
    PRIVATE_LABEL: {
        banner: 'tjx-banner-md.png',
        certificateHistoryImg: 'tjx-certHistory-md.png',
        certificateHistory: true,
        rewardsBalance: true,
        valuePropImg: 'tjx-valueProp-plcc.png',
        en: {
            disclaimer: 'If current points equal or exceed 1,000, a Rewards Certificate will be issued digitally within 24-48 hours. It will also be sent with your next statement.',
            propositions: [
                {
                    description: "Earn 5% back in Rewards points every time you shop our family of stores. That's 5 points for every $1 spent.*",
                    heading: 'earn',
                    points: '5% back'
                }
            ]
        },
        es: {
            disclaimer: 'Si los puntos actuales igualan o superan los 1000, se emitirá digitalmente un Certificado de Recompensa dentro de 24 a 48 horas. También se enviará con su próximo estado de cuenta.',
            propositions: [
                {
                    description: 'Obtenga 5% de reembolso en puntos de Recompensas cada vez que compra en nuestra familia de tiendas. Equivale a 5 puntos por cada $1 gastado.*',
                    heading: 'obtenga',
                    points: '5% de reembolso'
                }
            ]
        }
    }
};
export default tjx;
